var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process-wrapper",class:{ addGray: _vm.addGray }},[_c('div',{ref:"processChild",staticClass:"process-child"},[_c('p',{staticClass:"process-animate"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }